import arrayMove from "array-move";
import _ from "lodash";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import {
  portOperationHeader,
  termsCoEfficientTable
} from "../../constants";
import * as actions from "../../containers/User/Calculator/actions";
import { toastError } from "../../utils";
import CustomShowModal from "../Common/CustomShowModal";
import AddOperationsModal from "./AddOperationsModal";
import AddPortsModal from "./AddPortsModal";
import BunkerSupply from "./BunkerSupply";
import DraggableList from "./DraggableList";
import MarginAllowancesTable from "./MarginAllowancesTable";
import PortDistanceModal from "./PortDistanceModal";


function PortOperations(props) {
  const {
    disableEdit = false,
    sendCalculationRequest = () => { },
    calculatorData = [],
    setCalculatorData = () => { },
    onChangePortOperations = () => { },
    marginModal = false,
    setMarginModal = () => { },
    syncBunker = true,
    setSyncBunker = () => { },
    onAddOperations = () => { },
    onDeleteOperations = () => { },
    selectedVessels = {},
    supplyModal = false,
    setSupplyModal = () => { },
    onChangeSyncBunker = () => { },
    onFetchPortOperationDistance = () => { },
    fetchPortDistance = () => { },
    onClickCalculateAndSave = () => { sendCalculationRequest({ ...calculatorData, autoSave: false }) },
    openAddOperation = false,
    setOpenAddOperation = () => { },
    setOpenAddOperationindex = () => { },
    onChangeSelectedVessel = () => { },
    isOverride = false,
    setIsOverride = () => { },
    onChangePortCanalInQueryState = () => { },
    isContractEstimate = false,
    selectedColumns = [],
  } = props;

  const { portOperation = [], clientQuery = {} } = calculatorData || {};
  const { cargoTransactionMode = false } = clientQuery;

  const [termsModal, setTermsModal] = useState(false);
  const [distanceModal, setDistanceModal] = useState(false);
  const [selectedOperation, setSelectedOperation] = useState({});
  const [addPortModal, setAddPortModal] = useState(false);
  const [portLoading, setPortLoading] = useState(false);
  const [portOptions, setPortOptions] = useState([]);

  const emptyAddOperation = {
    operation: "Bunkering",
    port: "",
    portExp: 0,
    extraDays: 0,
    lat: 0,
    lng: 0
  };
  const [initialAddOperation, setInitialAddOperation] = useState(emptyAddOperation);

  const showFreightSelection = clientQuery.freightMode === "Multiple Freight";

  let newPortOperationHeader = [...portOperationHeader];

  if (showFreightSelection) {
    newPortOperationHeader.splice(14, 0, {
      label: "Freight",
      width: 50,
    });
  }

  const getColumnStyle = (item) => ({
    minWidth: item.width,
    width: item.width,
    flex: `${item.width} 0 ${item.width}px`,
    paddingLeft: item?.paddingLeft,
  });

  const delayPortsSearch = useCallback(
    _.debounce(
      (selectedOperation, search, isInitialData = false) =>
        onSearchPortList(selectedOperation, search, isInitialData),
      500
    ),
    []
  );

  const containerRef = useRef(null);

  const handleSortStart = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  };

  const handleSortEnd = (sortParams) => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
    onSortEnd(sortParams);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) return;
    if (
      portOperation[oldIndex].operation === "Commence" ||
      portOperation[newIndex].operation === "Commence"
    )
      return;
    let newCombinedOperation = arrayMove(portOperation, oldIndex, newIndex);

    // Block only when a Loading port ends up after the LAST Discharging port.
    // Interleaved patterns (Loading between Discharge ports) are valid.
    let lastDischargingIndex = -1;
    let lastLoadingIndex = -1;
    for (let i = 0; i < newCombinedOperation.length; i++) {
      if (newCombinedOperation[i].operation === "Discharging") {
        lastDischargingIndex = i;
      }
      if (newCombinedOperation[i].operation === "Loading") {
        lastLoadingIndex = i;
      }
    }
    if (
      lastDischargingIndex !== -1 &&
      lastLoadingIndex !== -1 &&
      lastLoadingIndex > lastDischargingIndex
    ) {
      toastError("Loading operations cannot be moved below Discharging operations");
      return;
    }

    if (props.onReorder) {
      props.onReorder(oldIndex, newIndex);
    } else {
      const updatedData = {
        ...calculatorData,
        portOperation: [...newCombinedOperation].map((item, index) => ({
          ...item,
          index,
        })),
      };
      setCalculatorData(updatedData);
      onFetchPortOperationDistance(false, updatedData, {}, true);
    }
  };

  const onClickHeaderModal = (headerName) => {
    if (headerName === "Terms") {
      setTermsModal(true);
    } else if (headerName === "Supply") {
      setSupplyModal(true);
    } else if (headerName === "Dist Normal" || headerName === "Dist ECA") {
      setDistanceModal(true);
    } else {
      return;
    }
  };

  const onChangeBunkerScrubber = (index, e) => {
    const { name = "", value = "" } = e.target;
    let newPortOperation = [...portOperation];
    newPortOperation[index].cargoDetails[name] = Number(value);
    setCalculatorData({ ...calculatorData, portOperation: newPortOperation });
  };

  const onClickSinglePort = (operation, index) => {
    if (disableEdit) return toastError("Changing ports is disabled in this view.");
    setSelectedOperation({ ...operation, _portIndex: index });
    setAddPortModal(true);
  };

  const onSearchPortList = (
    selectedOperation,
    value,
    isInitialData = false
  ) => {
    if (isInitialData) {
      setInitialAddOperation({ ...selectedOperation, port: value });
    } else {
      setSelectedOperation({ ...selectedOperation, port: value });
    }
    if (value) {
      setPortLoading(true);
      actions
        .portsByChar(value)
        .then((res) => {
          setPortLoading(false);
          setPortOptions(
            (Array.isArray(res.data.list) &&
              res.data.list.map((item) => ({
                label: `${item.name} ${item.country ? "(" + item.country + ")" : ""
                  }`,
                value: item.name,
                lat: item?.lat,
                lng: item?.lng
              }))) ||
            []
          );
        })
        .catch((err) => {
          setPortLoading(false);
        });
    }
  };

  const onSelectPortsOfOperation = (selectedPort) => {
    let portIndex = selectedOperation._portIndex;
    if (portIndex === undefined) {
      portIndex = portOperation.findIndex(
        (item) => item._id === selectedOperation._id
      );
    }
    if (portIndex > -1) {
      const updatedOperation = [...portOperation];
      updatedOperation[portIndex].port = selectedPort.value;
      updatedOperation[portIndex].lat = selectedPort.lat;
      updatedOperation[portIndex].lng = selectedPort.lng;
      setSelectedOperation({ ...selectedOperation, port: selectedPort.value });
      if (props.onPortChange) {
        props.onPortChange(portIndex, selectedPort);
        setAddPortModal(false);
      } else {
        setCalculatorData({
          ...calculatorData,
          portOperation: updatedOperation,
        });
      }
    }
  };

  const onClickCalculateDistance = () => {
    onFetchPortOperationDistance(false, null, {}, true);
    setAddPortModal(false);
  };

  const onAddOperationByModal = () => {
    const {
      operation = "",
      port = "",
      portExp = 0,
      portStay = 0,
    } = initialAddOperation;
    if (!operation || !port) {
      return toastError("Port is required");
    }
    onAddOperations(initialAddOperation);
    setOpenAddOperation(false);
    // fresh form for the next port
    setInitialAddOperation(emptyAddOperation);
    setPortOptions([]);
    setPortLoading(false);
  };

  const dischargedPortIndexes = useMemo(() => {
    let indexes = [];
    for (let i = 0; i < portOperation.length; i++) {
      if (portOperation[i].operation === "Discharging") {
        indexes.push(i);
      }
    }
    indexes.splice(indexes.length - 1, 1);
    return indexes;
  }, [portOperation]);

  const onSetCargoTxOverride = (checked) => {
    const updatedPortOperation = [...portOperation];
    for (let i = 0; i < dischargedPortIndexes.length; i++) {
      updatedPortOperation[dischargedPortIndexes[i]].cargoTxOverriddenValue = 0;
      updatedPortOperation[dischargedPortIndexes[i]].cargoTx = 0;
    }
    setCalculatorData({
      ...calculatorData,
      clientQuery: { ...clientQuery, cargoTransactionMode: checked },
      portOperation: updatedPortOperation,
    });
  };

  const termsToDisplay = termsCoEfficientTable.filter(
    (item) => item.value !== 0
  );

  let showModal = ["Dist Normal", "Dist ECA", "Terms", "Supply"];
  if (disableEdit) showModal = showModal.filter((item) => {
    return item !== "Supply"
  })

  return (
    <div
      ref={containerRef}
      style={{ overflowX: "auto", overflowY: "hidden" }}
      className="operation-background calculator-port-operation-table scroll-thin"
      onScroll={(e) => {
        if (e.currentTarget.scrollTop !== 0) {
          e.currentTarget.scrollTop = 0;
        }
      }}
    >
      <div className="port-operation-header rounded-none">
        {newPortOperationHeader.map((item, index) => {
          if (item.label !== "" && selectedColumns.length && !selectedColumns.includes(item.label)) return null;

          const isModalField = showModal.includes(item.label);

          if (disableEdit && item.label === "Add Opr..") {
            return
          }
          return (
            <div key={index} style={getColumnStyle(item)}>
              <span
                className={item.label === "Cargo Tx" ? "cargo-tx-header" : undefined}
                style={{
                  cursor: isModalField ? "pointer" : "default",
                  color: "#ffffff",
                  textDecoration: isModalField ? "underline" : "none",
                  textAlign: item.width <= 30 ? "center" : "left",
                }}
                onClick={() => {
                  if (isModalField) {
                    onClickHeaderModal(item.label);
                  }
                }}
              >
                {item.label}
                {item.label === "Cargo Tx" ? (
                  <input
                    type="checkbox"
                    aria-label="Toggle Cargo Tx override"
                    checked={cargoTransactionMode}
                    onChange={(e) => onSetCargoTxOverride(e.target.checked)}
                  />
                ) : null}
              </span>
            </div>
          );
        })}
      </div>

      {portOperation.length ? (
        <DraggableList
          useDragHandle
          lockAxis="y"
          lockToContainerEdges={true}
          autoScroll={false}
          helperClass="SortableHelper"
          onSortStart={handleSortStart}
          onSortEnd={handleSortEnd}
          onChangePortOperations={onChangePortOperations}
          combinedOperation={portOperation}
          onDeleteOperations={onDeleteOperations}
          onClickSinglePort={onClickSinglePort}
          showFreightSelection={showFreightSelection}
          cargoTxOverride={cargoTransactionMode}
          dischargedPortIndexes={dischargedPortIndexes}
          setOpenAddOperation={setOpenAddOperation}
          setOpenAddOperationindex={setOpenAddOperationindex}
          disableEdit={disableEdit}
          selectedColumns={selectedColumns}
        />
      ) : (
        <div className="no-port-found-div">
          <p>No port operations found.</p>
        </div>
      )}

      {/* ALL YOUR ORIGINAL MODALS BELOW — UNCHANGED */}

      <CustomShowModal
        open={termsModal}
        handleClose={() => setTermsModal(false)}
        maxWidth="none"
        title="Terms Co-efficient Table"
      >
        <div className="w-[260px] border border-slate-300 rounded-none overflow-hidden my-0.5">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-[#f0f2f5] border-b border-slate-300">
                <th className="px-2.5 py-1 text-[11px] font-medium text-slate-700 border-r border-slate-300">
                  Terms (Contract Type)
                </th>
                <th className="px-2.5 py-1 text-[11px] font-medium text-slate-700 text-right">
                  Multiplier (Factor)
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 bg-white">
              {termsToDisplay.map((term, index) => (
                <tr key={index} className="hover:bg-slate-50 transition-colors">
                  <td className="px-2.5 py-0.5 text-[11px] font-medium text-slate-800 border-r border-slate-200">
                    {term.label}
                  </td>
                  <td className="px-2.5 py-0.5 text-[11px] font-medium text-slate-800 text-right">
                    {term.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CustomShowModal>

      <CustomShowModal
        open={supplyModal}
        handleClose={() => setSupplyModal(false)}
        maxWidth="lg"
        title="Bunker Supply Table"
      >
        <BunkerSupply
          portOperation={portOperation}
          syncBunker={syncBunker}
          setSyncBunker={setSyncBunker}
          clientQuery={clientQuery}
          onChangeBunkerScrubber={onChangeBunkerScrubber}
          selectedVessels={selectedVessels}
          onChangeSyncBunker={onChangeSyncBunker}
          onChangeSelectedVessel={onChangeSelectedVessel}
          onChangePortOperations={onChangePortOperations}
          isOverride={isOverride}
          setIsOverride={setIsOverride}
        />
      </CustomShowModal>

      <CustomShowModal
        open={marginModal}
        handleClose={() => setMarginModal(false)}
        maxWidth="sm"
        title="Margin Allowances Table"
      >
        <MarginAllowancesTable
          calculatorData={calculatorData}
          setCalculatorData={setCalculatorData}
        />
      </CustomShowModal>

      <CustomShowModal
        open={distanceModal}
        handleClose={() => setDistanceModal(false)}
        maxWidth="lg"
        title="Port Distance"
      >
        <PortDistanceModal
          calculatorData={calculatorData}
          setCalculatorData={setCalculatorData}
          onFetchPortOperationDistance={onFetchPortOperationDistance}
          onChangePortCanalInQueryState={onChangePortCanalInQueryState}
          onClose={() => setDistanceModal(false)}
          onClickCalculateAndSave={onClickCalculateAndSave}
        />
      </CustomShowModal>

      <CustomShowModal
        open={addPortModal}
        handleClose={() => setAddPortModal(false)}
        maxWidth="xs"
        title={`Change ${selectedOperation.operation} Port`}
      >
        <AddPortsModal
          selectedOperation={selectedOperation}
          delayPortsSearch={delayPortsSearch}
          portOptions={portOptions}
          portLoading={portLoading}
          onClickCalculateDistance={onClickCalculateDistance}
          onSelectPortsOfOperation={onSelectPortsOfOperation}
        />
      </CustomShowModal>

      <CustomShowModal
        open={openAddOperation}
        handleClose={() => setOpenAddOperation(false)}
        maxWidth="xs"
        title={`Add Operation`}
      >
        <AddOperationsModal
          selectedOperation={selectedOperation}
          delayPortsSearch={delayPortsSearch}
          portOptions={portOptions}
          portLoading={portLoading}
          initialAddOperation={initialAddOperation}
          setInitialAddOperation={setInitialAddOperation}
          onClickCalculateDistance={onClickCalculateDistance}
          onSelectPortsOfOperation={onSelectPortsOfOperation}
          onAddOperationByModal={onAddOperationByModal}
        />
      </CustomShowModal>

    </div>
  );
}

export default memo(PortOperations);
